<template>
  <div class="article-preview m-container-max">
    <div class="x-qrcode" v-if="isPC">
      <div class="qrcode-text">
        <span style="font-size: 16px;">美信扫码预览文章</span>
      </div>
      <div id="qrcode"></div>
    </div>
    <ArticleTemplate :article-detail="articleDetail"></ArticleTemplate>
  </div>
</template>

<script>
import ArticleTemplate from '../components/ArticleTemplate'
import { articleMixin } from '../mixins/article'
import QRCode from 'qrcodejs2'
import Vue from 'vue'
import { isPC, isMideaConnect, getCookie, getCookieOfToken } from '../utils/utils'
export default {
  components: {
    ArticleTemplate
  },
  data () {
    return {
      articleDetail: { title: '', createDataTime: '', author: '' },
      token: '',
      isPC: isPC()
    }
  },
  mixins: [articleMixin],
  computed: {
    isMideaConnect () {
      return isMideaConnect()
    }
  },
  methods: {
    weixinShare () {
      const self = this
      if (window.isWxTagLaunch) {
        window.wx.ready(function () {
          window.wx.onMenuShareAppMessage({
            title: self.articleDetail.title,
            link: window.location.href,
            imgUrl: self.articleDetail.coverImg,
            desc: self.articleDetail.summary,
            success: function () {
              console.log('share app message success!!!')
            }
          })
          window.wx.onMenuShareTimeline({
            title: self.articleDetail.title,
            link: window.location.href,
            imgUrl: self.articleDetail.coverImg,
            success: function () {
              console.log('share timeline success!!!')
            }
          })
        })
      }
    },
    initQRcode () {
      const reg = /base_appkey=(.*?)&/gi
      let baseAppkey = window.location.href.match(reg)[0]
      baseAppkey = baseAppkey.substring(12, baseAppkey.length - 1)
      const baseAppkeyArr = baseAppkey.split(',')
      let mxBaseAppkey = baseAppkeyArr[0]
      if (baseAppkeyArr.length > 1) {
        for (let i = 1; i < baseAppkey.length; i++) {
          mxBaseAppkey = mxBaseAppkey.length < baseAppkey[i].length ? baseAppkey[i] : mxBaseAppkey
        }
      }
      const href = window.location.href.replace(reg, `base_appkey=${mxBaseAppkey}&`)
      const qrCode = new QRCode('qrcode', {
        width: 130,
        height: 130,
        text: href,
        colorDark: '#000',
        colorLight: '#fff'
      })
      console.log(qrCode)
    },
    getArticleDetail () {
      this.$store.dispatch('getArticleDetailMXP', { articleId: this.articleId, isThirdPartPlat: true, appKey: this.base_appkey, sid: this.sid, ssoToken: null })
        .then(data => {
          // console.log(data)
          // this.handleArticleData(data)
          this.handleArticleData(data)
          this.weixinShare()
        })
    },
    validateParams () {
      this.articleId = this.$route.query.id
      this.base_appkey = this.$route.query.base_appkey
      this.sid = this.$route.query.sid
      if (typeof this.sid === 'undefined' && typeof this.base_appkey === 'undefined') {
        this.sid = '237'
        this.base_appkey = sessionStorage.getItem('appkey') || '94624bb4,58031799-ea11-4bb7-b3db-68a9b438766c'
      }
      if (typeof this.sid === 'undefined') {
        this.sid = '237'
      }
      if (typeof this.base_appkey === 'undefined') {
        this.base_appkey = sessionStorage.getItem('appkey') || '94624bb4,58031799-ea11-4bb7-b3db-68a9b438766c'
      }
      return true
    }
  },
  created () {
    if (this.isMideaConnect) {
      if (!sessionStorage.getItem('token')) {
        sessionStorage.setItem('token', getCookieOfToken('token'))
      }
      if (!sessionStorage.getItem('appkey')) {
        sessionStorage.setItem('appkey', getCookie('appkey'))
      }
      if (!sessionStorage.getItem('username')) {
        sessionStorage.setItem('username', getCookie('username'))
      }
    }
    if (this.validateParams()) {
      const result = {
        data: {
          // global CONFIG
          /* eslint-disable */
          baseUrl: CONFIG.baseUrl
          /* eslint-enable */
        }
      }
      Vue.prototype.$baseUrl = result.data.baseUrl
      this.getArticleDetail()
    }
  },
  mounted () {
    if (this.isPC) {
      this.initQRcode()
    }
  }
}
</script>

<style scoped>
  .x-qrcode {
    position: fixed;
    top: 9.375rem;
    right: 1.25rem;
    bottom: 0;
    z-index: 10005;
  }
  .qrcode-text {
    border: 1px solid #333;
    text-align: center;
    margin-bottom: .3125rem;
  }
</style>
